
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { TextField, Button, Box, Typography, LinearProgress, styled, IconButton, CircularProgress, Tooltip, useTheme } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import Upload_img from "../../../../assets/baseVersion/Upload_img.svg";
import Upload_img_dark from "../../../../assets/Upload_img_dark.svg";
import { toast } from "react-toastify";
import UploadService from "../../../../shared/UploadService";
import axiosInstance from "../../../../axios/axios";
import VendorMismatchDialog from "./VendorMismatchDialog";
import { useDispatch, useSelector } from "react-redux";
import SubscriptionMessage from "./SubscriptionMessage";
import { useNavigate } from "react-router-dom";
import DescriptionIcon from '@mui/icons-material/Description';
import { useStorageManager } from "../../../../shared/hooks";
import { END_POINTS } from "../../../../shared";
import { resetUserTypeFlags, setIsBothCloudAndPremAssetUser, setIsNewUserTrue, setIsOnlyCloudUser, setIsOnlyPremAssetUser } from "../../../../modules/authentication/login/Login_Details_slice";
import { RootState } from "../../../../store/store";




interface Props {
    onDirty?: (dirty: boolean) => void; // Tracks dirty state for unsaved changes
    onSubmit?: () => void; // Optional callback on submit
    vendorSelected?: any; // Make selectedVendor optional
}
interface FileSubmitRequest {
    event_id?: any;
    deleted_data?: any[];
    name?: string
}



const UploadFile: React.FC<Props> = ({ onDirty, vendorSelected }) => {
    const dispatch = useDispatch();
    const Details_Data: any = useSelector((state: any) => state.auth?.userData?.data);
    const [deviceCount, setDeviceCount] = useState<any | null>(
        Details_Data?.subscription_features?.device_count || -1
    )
        ;
    const subscriptionData: any = useSelector((state: RootState) => state.auth.subscriptionData);
    console.log(subscriptionData.device_count)
    const navigate = useNavigate();
    //const [deviceCount, setDeviceCount] = useState<any | null>(-1);
    const [totalExistingDevices, setTotalExistingDevices] = useState<any | null>(null);
    const [selectedVendor, setSelectedVendor] = useState<any | null>(
        vendorSelected?.id || null
    );
    const { getFromLocalStorage, saveToLocalStorage } = useStorageManager();
    const [allTempFiles, setAllTempFiles] = useState<any[]>([]);
    const [files, setFiles] = useState<any[]>([]);
    const [fileObjects, setFileObjects] = useState<{}[]>([]);
    const [invalidFileObjects, setInvalidFileObjects] = useState<any[]>([]);
    const [vendorMismatchObjects, setVendorMismatchObjects] = useState<any[]>([]);
    const [uploadPercentage, setUploadPercentage] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    //const [deviceCount, setDeviceCount] = useState<number>(-1); // -1 for unlimited
    const [previousSize, setPreviousSize] = useState(0);
    const [duplicateFilesTemp, setDuplicateFilesTemp] = useState<File[]>([]);
    const [event_id, setEventId] = useState<any>(null);
    const [batchIncrement, setBatchIncrement] = useState(0);
    const [scanName, setScanName] = useState<string>("");
    const [error, setError] = useState("");
    const [isDirty, setIsDirty] = useState<boolean>(false);
    const [fileSubmitRequest, setFileSubmitRequest] = useState<FileSubmitRequest>({});
    const [openDialog, setOpenDialog] = useState(false);
    const [open, setOpen] = useState(false);
    const [dialogData, setDialogData] = useState<any>({});
    const [deviceLimitExceeded, setDeviceLimitExceeded] = useState(false);
    const [connect, setConnect] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false);
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === "dark";
    const VisuallyHiddenInput = styled("input")({
        clip: "rect(0 0 0 0)",
        clipPath: "inset(50%)",
        height: 1,
        overflow: "hidden",
        position: "absolute",
        bottom: 0,
        left: 0,
        whiteSpace: "nowrap",
        width: 1,
    });
    useEffect(() => {
        //const dirtyState = scanName.trim() !== "";
        if (scanName.trim() !== "" || fileObjects.length > 0) {
            setIsDirty(true);
            if (onDirty) { onDirty(true); } // Call this function when scanName or fileObjects change
        } else {
            setIsDirty(false);
            if (onDirty) { onDirty(false); }

        }


        console.log(fileObjects)
        console.log(fileSubmitRequest)
        //setFileSubmitRequest(fileSubmitRequest)


    }, [scanName, fileObjects, fileSubmitRequest, onDirty]);

    const showDialog = (userDetails: any = null, deleted_data: any = null, totalExisDevices: any = null) => {
        setDialogData({
            title: `You have reached the limit of ${subscriptionData.device_count} assets in your plan!`,
            content: deleted_data ? `Currently you have ${totalExisDevices} active assets & ${deleted_data} deleted assets. To add more assets, Please upgrade to our paid plan.` : `Currently you have ${totalExisDevices} active assets. To add more assets, please upgrade to our paid plan.`,
            buttons: [
                {
                    label: "Cancel",
                    class: "btn-grayborder",
                    callBack: () => console.log("Cancel clicked"),
                },
                {
                    label: "Upgrade",
                    class: "btn-primary",
                    callBack: () => console.log("Upgrade clicked"),
                },
            ],
        });

        setOpen(true); // Open dialog after setting data
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setScanName(value);
        setError(value.trim() ? "" : "Scan name is required");
    };
    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        const droppedFiles = Array.from(e.dataTransfer.files);


        const fakeEvent = {
            target: { files: droppedFiles }
        };

        handleFileChange(fakeEvent);
    };
    const handleDragOver = useCallback((e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
    }, []);

    const handleDragEnter = useCallback((e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
    }, []);

    const handleDragLeave = useCallback((e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
    }, []);
    const deleteFile = (index: number, name: any) => {
        setFileObjects(prevFileObjects => {
            const updatedFileObjects = prevFileObjects.filter((_, i) => i !== index);

            // Find the deleted file to get its file_id
            const deletedFile: any = prevFileObjects[index];
            setPreviousSize(previousSize => previousSize - deletedFile.fileSize)
            if (deletedFile?.file_id) {
                setFileSubmitRequest(prev => ({
                    ...prev,
                    deleted_data: [...(prev.deleted_data || []), deletedFile.file_id]
                }));
            }
            const revisednewDeviceCount = updatedFileObjects.filter((file: any) => file.new_device).length;
            let eligible_count = deviceCount - totalExistingDevices;
            if (revisednewDeviceCount == eligible_count) {
                setDeviceLimitExceeded(false);
            }
            // If all files are deleted, reset event_id
            if (updatedFileObjects.length === 0) {
                setEventId(null);
            }
            return updatedFileObjects.sort((a, b) => Number(b.invalid) - Number(a.invalid));
        });
    };
    const addFiles = (newFiles: File[]) => {
        const allowedTypes = ["text/xml", "application/json", "text/plain"];
        const validFiles = newFiles.filter((file) =>
            allowedTypes.includes(file.type)
        );

        // Check for duplicates in all files
        validFiles.forEach((file) => {
            const isDuplicate = files.some(existingFile => existingFile.name === file.name);
            if (isDuplicate) {
                toast.error(`You have uploaded a duplicate file: ${file.name}`);
            }
        });

        if (validFiles.length > 0) {
            // Filter out the files that are already present (duplicates)
            const uniqueFiles = validFiles.filter((file) =>
                !files.some(existingFile => existingFile.name === file.name)
            );

            // Only add unique files to the state
            if (uniqueFiles.length > 0) {
                //setFiles([...files, ...uniqueFiles]);
                //setError(""); // Reset error if files are valid
            }
        } else {
            //setError("Only XML, JSON, and TEXT files are supported.");
            toast.error("Only XML, JSON, and TEXT files are supported."); // Show toast error
        }
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement> | any) => {
        const newFiles = event.target.files;
        if (!newFiles) return;

        const uploadedFiles: File[] = Array.from(newFiles); // Convert FileList to an array

        // Validate file upload
        const totalFilesCount = fileObjects.length + newFiles.length;
        if (totalFilesCount <= deviceCount || deviceCount === -1) {
            const validationResult: any = UploadService.validateFileUpload(fileObjects, uploadedFiles, false, previousSize);
            if (validationResult && validationResult.totalSize) {
                setPreviousSize(validationResult.totalSize)

            }
            if (validationResult.isValid) {
                UploadService.removeDuplicateFiles(fileObjects, uploadedFiles, (duplicateFiles: any, filteredFiles: any) => {
                    if (duplicateFiles.length > 0 && duplicateFiles.length <= 10) {

                        toast.error(`Duplicate files: ${duplicateFiles.map((file: any) => file.name).join(', ')}`);
                    } else {
                        setDuplicateFilesTemp(duplicateFiles.length)
                    }
                    setAllTempFiles(prevFileObjects => [...prevFileObjects, ...filteredFiles]);
                    setFileObjects((prevFileObjects) => [
                        ...prevFileObjects,
                        ...filteredFiles.map((file: any) => ({
                            name: file.name,
                            uploading: true,
                            fileSize: file.size / 1024, // Convert size to KB   
                            // Add any other properties as needed
                        }))
                    ]);
                    setIsUploading(true);
                    //setAllTempFiles(filteredFiles);
                    uploadAllFilesInBatches(filteredFiles)
                    // Add valid files to the state
                    //setFiles((prevFiles) => [...prevFiles, ...filteredFiles]);

                    event.target.value = ''; // Reset input value
                });

            }
        } else {
            toast.error(`You can only upload ${deviceCount} files at a time.`);
        }

    };
    // Helper function to generate FormData
    const scanReq = (files: File[] = [], save: boolean = false, event_id: string | null = null, vendor_key: any | null = null) => {
        const formData = new FormData();

        // Append files to FormData
        files.forEach((file: File) => {
            if (file && file.name) {
                formData.append("resumes", file, file.name);
            } else {
                console.error("File is undefined or does not have a name:", file);
            }
        });

        // Append event_id if provided
        if (event_id !== null) {
            formData.append("event_id", event_id);
        }

        if (vendor_key != null) {
            formData.append("vendor_key", vendor_key)
        }

        formData.append("save", save ? 'true' : 'false');
        return formData;
    };

    // Reusable function to handle the POST API call
    const uploadFileBatch = async (formData: FormData): Promise<any> => {
        try {

            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                onUploadProgress: (progressEvent: any) => {
                    if (progressEvent.total) {
                        setUploadPercentage(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                    }
                },
                onRequest: () => {
                    console.log('Request has been sent');
                    setUploadPercentage(0);  // Reset progress when the request is first sent
                }
            };
            // Make the API call (replace 'yourApiEndpoint' with your actual API URL)
            const response = await axiosInstance.post(END_POINTS.FILECHUNKS, formData, config);

            // Assuming you get a JSON response
            if (response) {
                setUploadPercentage(100)
                return response.data; // return the response data
            } else {
                throw new Error(`Failed to upload: `);
            }
        } catch (error) {
            console.error("Error uploading files:", error);
            throw error;
        }
    };

    // Main function to handle the uploading of files
    const uploadAllFilesInBatches = async (allTempFiles: File[]) => {

        if (!allTempFiles || allTempFiles.length === 0) {
            console.error("No files to upload");
            return;
        }

        try {
            const files: Array<any> = [];
            let newDeviceCount = 0;
            let invalidFiles: string[] = [];
            let vendorMismatchFiles: any[] = []; // Array of objects
            let existingDevices = 0;
            //tIsSubmitting(true);
            const firstFile = allTempFiles[0];
            const initialFormData = scanReq([firstFile], false, event_id, selectedVendor);

            const initialResponse = await uploadFileBatch(initialFormData);
            existingDevices = initialResponse.data.total_devices;



            if (initialResponse.data.batch_size) {
                setBatchIncrement(initialResponse.data.batch_size);
            }
            if (initialResponse.data.event_id) {
                setFileSubmitRequest((prev) => ({
                    ...prev,
                    event_id: initialResponse.data.event_id,
                    deleted_data: [],
                }));
                setEventId(initialResponse.data.event_id);
            }

            if (initialResponse.data.invalid_files?.length) {
                invalidFiles = [...initialResponse.data.invalid_files];
            }
            if (initialResponse.data.Vendor_not_match?.length) {
                vendorMismatchFiles = [...initialResponse.data.Vendor_not_match];
            }

            if (initialResponse.data.file_data?.length) {
                const fileData = initialResponse.data.file_data[0];
                setFileObjects((prevFileObjects) => {
                    const updatedFileObjects = prevFileObjects.map((file: any) =>
                        file.name === fileData.file_name
                            ? {
                                ...file,
                                file_id: fileData.file_id,
                                fileSize: firstFile.size / 1024,
                                new_device: fileData.new_device,
                                invalid: invalidFiles.includes(firstFile.name),
                                uploading: false,
                                invalidVendor: vendorMismatchFiles.some(
                                    (vendorFile) => vendorFile.file_name === firstFile.name
                                ),
                            }
                            : file
                    );

                    // Sort so that invalid files come first
                    return updatedFileObjects.sort((a, b) => Number(b.invalid) - Number(a.invalid));
                });

                // const fileObject = {
                //     name: firstFile.name,
                //     fileSize: firstFile.size / 1024,
                //     new_device: fileData.new_device,
                //     file_id: fileData.file_id,
                //     invalid: invalidFiles.includes(firstFile.name), // Mark invalid
                //     invalidVendor: vendorMismatchFiles.some(vendorFile => vendorFile.file_name === firstFile.name) // Check vendor mismatch
                // };

                if (fileData.new_device) newDeviceCount++;
                let remainingFiles: File[] = allTempFiles.slice(1);

                while (remainingFiles.length > 0) {
                    const batchFiles = remainingFiles.slice(0, initialResponse.data.batch_size);
                    const batchFormData = scanReq(batchFiles, false, initialResponse.data.event_id, selectedVendor);

                    const batchResponse = await uploadFileBatch(batchFormData);
                    existingDevices = batchResponse.data.total_devices;

                    if (batchResponse.data.invalid_files?.length) {
                        invalidFiles = [...invalidFiles, ...batchResponse.data.invalid_files];
                    }
                    if (batchResponse.data.Vendor_not_match?.length) {
                        vendorMismatchFiles = [...vendorMismatchFiles, ...batchResponse.data.Vendor_not_match];
                    }

                    if (batchResponse.data.file_data?.length) {
                        batchResponse.data.file_data.forEach((fileData: any, index: number) => {
                            const batchFile = batchFiles[index];
                            setFileObjects((prevFileObjects) => {
                                const updatedFileObjects = prevFileObjects.map((file: any) =>
                                    file.name === fileData.file_name
                                        ? {
                                            ...file,
                                            file_id: fileData.file_id,
                                            fileSize: batchFile.size / 1024,
                                            new_device: fileData.new_device,
                                            invalid: invalidFiles.includes(batchFile.name),
                                            uploading: false,
                                            invalidVendor: vendorMismatchFiles.some(
                                                (vendorFile) => vendorFile.file_name === batchFile.name
                                            ),
                                        }
                                        : file
                                );

                                // Sort: invalid files at the top
                                return updatedFileObjects.sort((a, b) => Number(b.invalid) - Number(a.invalid));
                            });


                            const batchFileObject = {
                                name: batchFile.name,
                                fileSize: batchFile.size / 1024,
                                new_device: fileData.new_device,
                                file_id: fileData.file_id,
                                invalid: invalidFiles.includes(batchFile.name),
                                invalidVendor: vendorMismatchFiles.some(vendorFile => vendorFile.file_name === batchFile.name)
                            };

                            if (fileData.new_device) newDeviceCount++;

                            //setFileObjects(prevFileObjects => [...prevFileObjects, batchFileObject]);
                        });
                    }

                    remainingFiles = remainingFiles.slice(initialResponse.data.batch_size);
                }


                //setFileObjects(prevFileObjects => [...prevFileObjects, fileObject]);
            }



            const hasInvalidVendor = fileObjects && fileObjects.length > 0 && fileObjects.some((file: any) => file.invalidVendor);
            console.log("hasInvalidVendor", hasInvalidVendor);

            if (hasInvalidVendor || vendorMismatchFiles.length > 0) {
                setOpenDialog(true); // Open the dialog
                //showDialog()

            }
            setTotalExistingDevices(existingDevices)
            if (deviceCount != -1) {
                let eligible_count = deviceCount - existingDevices;
                //3 -2 = 1
                if (eligible_count == 0) {
                    showDialog(null, null, existingDevices);
                }
                //2-1
                let previousNewDeviceCount = fileObjects.filter((file: any) => file.new_device).length;


                const totalnewDeviceCount = previousNewDeviceCount + newDeviceCount;
                if (totalnewDeviceCount > eligible_count) {
                    setDeviceLimitExceeded(true);
                    toast.error(`you can please remove ${totalnewDeviceCount - eligible_count} file inorder to continue`);

                }
            }




            //const eligibleCount = deviceCount - totalnewDeviceCount;
            if (invalidFiles.length > 0) {
                toast.error("You have uploaded invalid files, please remove them and try submitting again.");
            }

            console.log("Files uploaded successfully:", files);
            console.log("Invalid files:", invalidFiles);
            console.log("Vendor mismatched files:", vendorMismatchFiles);
            console.log("New device count:", newDeviceCount);
        } catch (error) {
            console.error("Error uploading all files:", error);
        } finally {
            setIsUploading(false)
            //setIsSubmitting(false);
        }
    };



    const handleSubmit = async (e: React.FormEvent | undefined = undefined, deletedIds: any = [], updatedRequest: any = null
    ) => {
        e?.preventDefault();
        if (isSubmitting) return; // Prevent multiple submissions

        if (fileObjects.length === 0) {
            setError("Please upload at least one file.");
            setIsSubmitting(false);
            return;
        }
        setIsSubmitting(true);

        setIsUploading(true);
        setError("");




        console.log("Uploaded files:", files);
        console.log("Scan Name:", scanName);

        try {
            let request: any = updatedRequest || fileSubmitRequest;
            request.event_id = event_id;
            if (scanName.trim() != "") {
                request.name = scanName;

            }
            if (deletedIds.length > 0) {
                request.deleted_data = [...request.deleted_data, ...deletedIds]

            }

            // request
            // if (scanName != "") {
            //     setFileSubmitRequest((prev) => ({
            //         ...prev,
            //         name: scanName, // replace with your dynamic value as a number
            //     }));
            // }
            const response: any = await axiosInstance.post(
                "securityscan/newscan/process-uploads",
                request
            );
            console.log("Upload Success:", response.data);
            if (response.status = 200) {
                toast.success(response.data.message)
                // const res = await axiosInstance.get(END_POINTS.IS_NEW_USER);
                // if(res.status === 200){
                //           const isNewUser = res?.data?.data || false;
                //           saveToLocalStorage("isNewUserDetails", isNewUser);
                //           
                // }
                await assetCount();
                navigate("/on-premises/scans")

            } else if (response.status = 501) {


            }

            // You can show success message here
        } catch (error: any) {
            console.error("Upload Error:", error);
            const response = error.response;
            if (response && response.data && response.data != null && response.data.status == 501 && response.data.data) {
                const data = response.data.data;
                const unscannedFilesArray = data.find((item: { hasOwnProperty: (arg0: string) => any; }) => item.hasOwnProperty('unscanned_files'));
                const deletedDeviceCountObject = data.find((item: { hasOwnProperty: (arg0: string) => any; }) => item.hasOwnProperty('deleted_device_count'));
                let deletedDeviceCountValue;
                if (deletedDeviceCountObject) {
                    deletedDeviceCountValue = deletedDeviceCountObject.deleted_device_count;
                }
                if (unscannedFilesArray && unscannedFilesArray.unscanned_files.length > 0) {
                    const unique_devices = Details_Data?.subscription_features?.unique_devices;
                    return unique_devices ? showDialog(Details_Data, deletedDeviceCountValue, totalExistingDevices) : showDialog(Details_Data, null, totalExistingDevices);
                }

            } else {
                navigate("/on-premises/scans")
                toast.error(response.data.message)

            }
            // if (response.data) {
            //     const unscannedFilesArray = response.data.find((item: { hasOwnProperty: (arg0: string) => any; }) => item.hasOwnProperty('unscanned_files'));
            //     const deletedDeviceCountObject = response.data.find((item: { hasOwnProperty: (arg0: string) => any; }) => item.hasOwnProperty('deleted_device_count'));
            //     let deletedDeviceCountValue;
            //     if (deletedDeviceCountObject) {
            //         deletedDeviceCountValue = deletedDeviceCountObject.deleted_device_count;
            //     }
            //     if (unscannedFilesArray && unscannedFilesArray.unscanned_files.length > 0) {
            //         const unique_devices = Details_Data?.subscription_features?.unique_devices;
            //         return unique_devices ? showDialog(Details_Data, deletedDeviceCountValue) : showDialog(Details_Data);
            //     }
            // } else {
            //     navigate("/onprem/scans")
            //     toast.error(response.message)

            // }
            // You can show error message here
        } finally {
            setIsUploading(false);
            setScanName("");
            setIsSubmitting(false);

        }



        //setFileObjects([]);
        //setProgress(0);
        // setIsUploading(false);
        // Reset after submission finishes
    };

    const assetCount = async () => {
        console.log("assetCount called");
        dispatch(resetUserTypeFlags());


        const res = await axiosInstance.get(END_POINTS.IS_NEW_USER);
        let parsed = null;
        if (res.status === 200) {
            dispatch(setIsOnlyPremAssetUser({ isOnlyPremAssetUser: false }));
            dispatch(setIsOnlyCloudUser({ isOnlyCloudUser: false }));
            dispatch(setIsBothCloudAndPremAssetUser({ isBothCloudAndPremAssetUser: false }));
            const isNewUser = res?.data?.data || false;
            parsed = res?.data?.data || false;
            if (parsed.device_count == 0 && parsed.cloud_count == 0) {
                dispatch(setIsNewUserTrue({ isNewUserTrue: true }));
                //dispatch(setIsOnlyCloudUser({ is: true }));

            }
            else if (parsed.device_count > 0 && parsed.cloud_count == 0) {
                dispatch(setIsOnlyPremAssetUser({ isOnlyPremAssetUser: true }));
            } else if (parsed.device_count == 0 && parsed.cloud_count > 0) {
                dispatch(setIsOnlyCloudUser({ isOnlyCloudUser: true }));
            } else if (parsed.device_count > 0 && parsed.cloud_count > 0) {
                dispatch(setIsBothCloudAndPremAssetUser({ isBothCloudAndPremAssetUser: true }));
            }
        }
    }

    const isSubmitDisabled = useMemo(() =>
        (fileObjects.length === 0 ||
            fileObjects.some((file: any) => file.invalid || file.invalidVendor) ||
            deviceLimitExceeded) && !isSubmitting,
        [fileObjects, deviceLimitExceeded]
    );

    const anyUploading = useMemo(
        () => fileObjects.some((file: any) => file.uploading),
        [fileObjects]
    );


    const handleConnect = (selectedVendor: string) => {
        console.log("User clicked connect button with selection:", selectedVendor);

        if (selectedVendor === "1") {
            // Extract file_ids of invalidVendor files
            const deletedIds = fileObjects
                .filter((file: any) => file.invalidVendor)
                .map((file: any) => file.file_id);

            // Update state correctly
            setFileSubmitRequest((prev) => {
                const updatedRequest = {
                    ...prev,
                    deleted_data: [...(prev.deleted_data || []), ...deletedIds],
                };
                console.log("Updated fileSubmitRequest:", updatedRequest); // Log the new state here
                handleSubmit(undefined, deletedIds, updatedRequest)
                return updatedRequest;
            });

        } else {
            handleSubmit(undefined)
        }
        console.log(fileSubmitRequest)


    };


    const handleCancel = () => {
        console.log("User clicked cancel button");
        // Add your logic when the user selects Cancel
    };

    console.log("nsdjfkds", fileObjects)
    console.log("fadfdsf", fileSubmitRequest)

    return (
        <>
            {isSubmitting && (
                <Box
                    sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                        zIndex: 1300, // above most MUI components
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <CircularProgress />
                </Box>
            )}
            <Box className="upload-file-container" onDrop={handleDrop}
                onDragOver={handleDragOver}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}>
                {/* Header */}
                <Box className="header-box" sx={{ mb: 2 }}>
                    <Typography sx={{ fontWeight: '600' }} variant="subtitle1">Upload configuration files to generate reports</Typography>
                    <Typography variant="body2">Define your scan name and start uploading..</Typography>
                </Box>

                {/* Scan Name Input */}
                <TextField
                    label="Scan Name (Optional)"
                    variant="outlined"
                    fullWidth
                    value={scanName}
                    onChange={handleInputChange}
                    sx={{ mb: 2 }}
                />

                {/* Drag and Drop Area */}
                {/* <Box
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                sx={{
                    border: "2px dashed #3A2ADA",
                    padding: "20px",
                    textAlign: "center",
                    mb: 2,
                    cursor: "pointer",
                }}
            >
                <Typography variant="body1">Drag & Drop your files here</Typography>
                <Typography variant="body2" color="textSecondary">
                    (Supported formats: XML / JSON / TXT)
                </Typography>
                <input type="file" hidden multiple onChange={handleFileChange} />
            </Box> */}

                {/* Choose File Button */}
                {/* <Button variant="contained" component="label" fullWidth sx={{ mb: 2 }}>
                Choose Files
                <input type="file" hidden multiple onChange={handleFileChange} />
            </Button> */}
                {fileObjects.length == 0 && (
                    <div
                        style={{
                            border: isDarkMode ? "1px dashed gray" : "1px dashed blue",
                            padding: "20px",
                            borderRadius: "10px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 5,
                            transition: "border-color 0.3s ease-in-out",
                            backgroundColor: "#DFDEEC4D",
                            marginBottom: 30,
                        }}
                    >
                        <Button
                            component="label"
                            variant="text"
                            sx={{
                                "&:hover": {
                                    backgroundColor: "transparent",
                                    color: "inherit",
                                },
                                color: "inherit",
                            }}
                        >
                            <Box textAlign="center">
                                <img src={isDarkMode ? Upload_img_dark : Upload_img} alt="" style={{ marginBottom: 10 }} />
                                <Typography
                                    className="upload-text"
                                    sx={{ color: "inherit", fontWeight: "bold", mb: 1 }}
                                >
                                    Upload files
                                </Typography>
                                <Typography
                                    className="upload-text"
                                    sx={{
                                        color: isDarkMode ? "#FFFFFF" : "#808080",
                                        fontWeight: "bold",
                                        mb: 1,
                                    }}
                                >
                                    or
                                </Typography>
                                <Typography
                                    className="upload-text"
                                    sx={{
                                        color: isDarkMode ? "#FFFFFF" : "#696595",
                                        fontWeight: 500,
                                        mb: 2,
                                    }}
                                >
                                    Drag and drop your files here or <span>choose files</span>
                                </Typography>
                                <Typography
                                    className="upload-text"
                                    sx={{
                                        color: isDarkMode ? "#FFFFFF" : "#696595",
                                        fontWeight: 500,
                                        mb: 2,
                                    }}
                                >
                                    (Supported file formats XML/TEXT/JSON)
                                </Typography>
                            </Box>

                            <VisuallyHiddenInput
                                type="file"
                                onChange={(event) => handleFileChange(event)}
                                multiple
                            />
                        </Button>
                    </div>
                )}

                <div className="uploaded-files-container">
                    {fileObjects.length > 0 && (
                        <div className="uploaded-files-section">
                            <div className="upload-header" style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: 10 }}>
                                <Typography
                                    variant="body2"
                                    className="uploaded-files"
                                    style={{ color: isDarkMode ? "white" : "black" }}
                                >
                                    {fileObjects.length} Files uploaded
                                </Typography>

                                <div className="add-more">
                                    <input
                                        type="file"
                                        className="file-upload hide"
                                        id="fileDropRef"

                                        multiple
                                        onChange={handleFileChange}
                                        style={{ display: "none" }}
                                    />
                                    <div className="browse-file-content">
                                        <Typography variant="body2" className="browse-text" onClick={() => document.getElementById("fileDropRef")?.click()}>
                                            Add More
                                        </Typography>
                                    </div>
                                </div>
                            </div>

                            <div className="scroll uploaded-list">
                                <ul>
                                    {fileObjects.map((file: any, index) => (
                                        <li
                                            key={index}
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                overflow: "hidden",
                                            }}
                                        >
                                            <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>

                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        justifyContent: "space-around",
                                                        alignItems: "center",
                                                        width: "100%",
                                                    }}
                                                >
                                                    <DescriptionIcon
                                                        sx={{
                                                            mr: 2,
                                                            color: isDarkMode ? "white" : "black"
                                                        }}
                                                    />

                                                    <span
                                                        title={file.name}
                                                        style={{
                                                            flex: 1,
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                            color:
                                                                file.invalid ||
                                                                    file.invalidVendor ||
                                                                    (file.new_device && deviceLimitExceeded)
                                                                    ? "red"
                                                                    : isDarkMode
                                                                        ? "white"
                                                                        : "black",

                                                        }}
                                                    >
                                                        {file.name}
                                                    </span>

                                                    {!file.uploading && (
                                                        <IconButton
                                                            onClick={() => deleteFile(index, file.name)}
                                                            color="default"
                                                            size="small"
                                                            sx={{
                                                                marginLeft: "10px",
                                                                color: file.invalid || file.invalidVendor || (file.new_device && deviceLimitExceeded) ? "red" : "inherit",
                                                            }}
                                                        >
                                                            <CloseIcon
                                                                fontSize="small"
                                                                sx={{
                                                                    color: isDarkMode ? "white" : "black"
                                                                }}
                                                            />

                                                        </IconButton>
                                                    )

                                                    }
                                                </div>

                                                {file.uploading && (
                                                    <Box sx={{ width: "100%" }}>
                                                        <LinearProgress variant="determinate" value={uploadPercentage} sx={{ mt: 2 }} />
                                                    </Box>
                                                )}
                                            </div>
                                        </li>

                                    ))}

                                </ul>
                            </div>
                        </div>
                    )}
                </div>
                {duplicateFilesTemp.length > 0 && (
                    <div>
                        <p className="info-icon">
                            <Tooltip title="Some custom tooltip" arrow>
                                <IconButton>
                                    <InfoIcon />
                                </IconButton>
                            </Tooltip>
                            <span className="text">
                                {duplicateFilesTemp.length} duplicate files found
                            </span>
                        </p>
                    </div>
                )}

                {/* Display uploaded files */}
                {/* {files.length > 0 && (
                <Box className="uploaded-files-container" sx={{ mt: 2 }}>
                    <Typography variant="subtitle2">{files.length} Files Uploaded:</Typography>
                    <ul>
                        {files.map((file, index) => (
                            <li key={index} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <span>{file.name}</span>
                                <Button onClick={() => handleRemoveFile(index)} size="small" color="error">
                                    ❌
                                </Button>
                            </li>
                        ))}
                    </ul>
                </Box>
            )}

            {error && (
                <Typography color="error" sx={{ mt: 1 }}>
                    {error}
                </Typography>
            )} */}

                {/* Upload Progress Bar */}
                {/* {isUploading && <LinearProgress variant="determinate" value={uploadPercentage} sx={{ mt: 2 }} />} */}

                {/* Submit Button */}
                {/* <Button
                    className="upload-submit"
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    disabled={isSubmitDisabled}
                    onClick={handleSubmit}
                    sx={{ mt: 2 }}
                >
                    {isUploading ? "Uploading..." : "Upload"}
                </Button> */}
                {fileObjects.length > 0 && (
                    <Button
                        className="upload-submit"
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={isSubmitDisabled || anyUploading || isSubmitting}
                        onClick={handleSubmit}
                        sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1 }}
                    >

                        {isSubmitting ? "Submitting..." : "Submit"}
                        {isSubmitting && (
                            <CircularProgress size={18} sx={{ color: "white" }} />
                        )}
                    </Button>

                )}
            </Box>
            <VendorMismatchDialog
                open={openDialog}
                handleClose={() => setOpenDialog(false)}
                onConnect={handleConnect}
                onCancel={handleCancel}
            />
            <SubscriptionMessage open={open} onClose={() => setOpen(false)} data={dialogData} />


        </>
    );
}

export default UploadFile;
